import React, { useEffect, useState } from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Line,
  Marker,
} from "react-simple-maps";

import hrTopo from "./haryana.json";

import "./mapdata.scss";

import { IStateMapdata } from "../../types";
import { Tooltip } from "react-tooltip";
import DotsSpinner from "../Loader/DotsSpinner/DotsSpinner";

type IProps = {
  data: IStateMapdata[];
  isLoading: boolean;
  setSelcetdistrict: (district: string) => void;
};
type IContent = {
  district: string;
  EAdhigam: any;
};
// url to a valid topojson file
const MapData = ({ data, setSelcetdistrict, isLoading }: IProps) => {
  const [content, setContent] = useState<IContent>({
    district: " ",
    EAdhigam: "",
  });
 
  useEffect(() => {
    hrTopo.objects.haryanamap.geometries.forEach((eachDistrict) => {
      let districtName = eachDistrict.properties.District;
      let distData = data?.find(
        (each) =>
          each.district.toLowerCase().trim() ===
          districtName.toLowerCase().trim()
      );
      // window.alert(distData);
      // console.log(distData);
      if (distData) {
        eachDistrict.properties.REMARKS =
          Number(distData?.Avg_Adhigam_students);
      }else{
        eachDistrict.properties.REMARKS = 0;
      }
    });
    // (Number(distData.e_adhigam_students) /
    //   Number(distData.total_students)) *
    //   100 || 0;
  }, [data]);
  

  return (
    <div>
      <div className="bg-primary  py-1 rounded flex-centered mt-4">
        <h3 className="text-white m-0">e-Adhigam Students Map</h3>
      </div>
      {!!content.EAdhigam ? (
        <Tooltip className="ml-4 mt-4 d-flex justify-content-center ">
          <h2>{content?.district.toUpperCase()}</h2>
        </Tooltip>
      ) : (
        <div style={{ height: "62px" }}></div>
      )}
      {isLoading ? (
        <div className="bg-body" style={{ height: "300px" }}>
          <DotsSpinner />
        </div>
      ) : (
        <div
          data-tip=""
          className="bg-light-subtle shadow-sm rounded"
          onClick={() =>{ console.log("clcick om map ")
             setSelcetdistrict(content?.district)
            }}
        >
          <ComposableMap
            projection="geoAzimuthalEqualArea"
            height={410}
            width={380}
            projectionConfig={{
              rotate: [-76.1, -29.323, 0],
              scale: 7000,
            }}
          >
            <Geographies geography={hrTopo} className="bg-info-subtle ">
              {({ geographies }) =>
                geographies.map((geo, index) => (
                  <>
                    <Geography
                      key={geo?.properties?.name}
                      geography={geo}
                      onMouseEnter={() => {
                        setContent({
                          district: geo?.properties?.name,
                          EAdhigam: geo?.properties?.REMARKS.toFixed(2),
                        });
                        console.log(geo?.properties?.REMARKS)
                      }}
                      onMouseLeave={() => {
                        setContent({ district: "", EAdhigam: "" });
                      }}
                      className="pointer"
                      style={{
                        default: {
                          fill:
                          geo.properties.REMARKS  ? 
                          geo.properties.REMARKS > 60 
                            ? 
                            "#4CBB17" 
                            :
                             (geo.properties.REMARKS >= 30 && geo.properties.REMARKS <= 60) 
                             ? 
                             "#FFFF1B" 
                             :
                              "#ff3333" 
                              :
                              "#ff3333"
                        },
                        hover: {
                          fill: "#038aa1",
                        },
                        pressed: {
                          fill: "#E42",
                        },
                      }}
                    />
                    <Marker coordinates={geoCentroid(geo)}>
                      <g onClick={()=>console.log(geo?.properties?.name)}>
                      <text y="4" x="-2" fontSize={7.6} textAnchor="middle" onMouseOver={()=>setContent({
                          district: geo?.properties?.name,
                          EAdhigam: geo?.properties?.REMARKS.toFixed(2),
                        })}
                        className="pointer"
                        onMouseLeave={()=>setContent({ district: "", EAdhigam: "" })}
                         onClick={()=>setSelcetdistrict(content?.district)}>
                        {geo?.properties?.name.toUpperCase()}
                      </text>
                      </g>
                    </Marker>
                  </>
                ))
              }

            </Geographies>
          </ComposableMap>
      <div className="legend">
        <div className="item">
          <div className="item__red"></div>
          <div className="label">{`< 30%`}</div>
        </div>
        <div className="item">
          <div className="item__yellow"></div>
          <div className="label">{`> 30% and < 60%`}</div>
        </div>
        <div className="item">
          <div className="item__green"></div>
          <div className="label">{`> 60%`}</div>
        </div>
      </div>
        </div>
      )}
    </div>
  );
};

export default MapData;

{
  /* <ComposableMap
          projection="GeometryCollection"
            projectionConfig={{
              rotate: [-76, -29, 0],
              scale: 6500,
            }}
        >
          <Geographies geography={geoUrl}>
          <Geographies geography="./haryana.geojson">
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  name={geo?.properties?.district}
                  onMouseEnter={() => {
                    setContent(geo?.properties?.district);
                  }}
                  onMouseLeave={() => {
                    setContent("");
                  }}
                  style={{
                    default: {
                      fill: "#D6D6DA",

                      outline: "EAEAEC",
                    },
                    hover: {
                      fill: "#F53",
                      outline: "none",
                    },
                    pressed: {
                      fill: "#E42",
                      outline: "none",
                    },
                  }}
                />
              ))
            }
          </Geographies>
        </ComposableMap> */
}
